module.exports = __webpack_public_path__ + "img/hp.7f9ba9c3.png";